import Vue from 'vue'
import VScrollLock from 'v-scroll-lock'

Vue.use(VScrollLock)
